export default __webpack_public_path__ + "static/media/success.0ebe34c2.png";